import { Modal, Progress, Spin, Typography } from 'antd';
import { useAppSelector } from 'src/redux/hook';
import { JOB_STATUS } from 'src/shared/constants';

const ModalJobProgress = () => {
  const { isJobProgressModalOpen, jobProcessedCount, jobTotalCount, jobStatusName, jobStatus } =
    useAppSelector((state) => state.global);

  const percent = [JOB_STATUS.Done].includes(jobStatus as unknown as JOB_STATUS)
    ? 100
    : jobTotalCount > 0
    ? Math.min(100, Math.round((jobProcessedCount / jobTotalCount) * 100))
    : 0;

  return (
    <Modal
      open={isJobProgressModalOpen}
      footer={false}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={420}
      destroyOnClose
    >
      <div className='flex justify-between items-center'>
        <div>
          <Typography.Title level={5} className='mb-4'>
            Hệ thống đang xử lý dữ liệu
          </Typography.Title>
          <Typography.Text className='block mb-2'>
            Trạng thái: {jobStatusName || 'Processing'}
          </Typography.Text>
        </div>
        <Spin />
      </div>
      <Typography.Text className='block mb-3'>
        Tiến độ: {jobProcessedCount}/{jobTotalCount}
      </Typography.Text>
      <Progress percent={percent} status='active' />
    </Modal>
  );
};

export default ModalJobProgress;
